import { ReduxConfigService } from "./redux-config.service";
import { Inject, Injectable, Optional} from "@angular/core";
import { combineReducers } from "@ngrx/store";
import { ReducerConfig, ReducerToken } from "../model/reducer-config.model";
import { RESET_REDUX_STATE } from "../action/common/core.action.factory";

/**
 * This is the default implementation of the {@link ReduxConfigService}. It uses the multi-provider option in the DI system of Angular.
 */
@Injectable()
export class ReduxConfigServiceImpl implements ReduxConfigService {

  constructor(
    @Optional() @Inject(ReducerToken) private _mainReducers: ReducerConfig[]) {
  }

  /**
   * This method returns the reducer hierarchy of the application.
   *
   * @returns {Reducer<S>} The root reducer function of the application.
   */
  public getRootReducer(): Function {
    // we return an empty function if there is no reducers registered
    if (!this._mainReducers) {
      return (state, action) => state;
    }

    const allMainReducers: ReducerConfig[] = this._mainReducers || [];

    const mainReducers = this.processReducerConfigArray(allMainReducers);

    const rootReducer = combineReducers(mainReducers);

    return (state, action) => {
      if (action.type === RESET_REDUX_STATE) {
        state = undefined;
      }

      return rootReducer(state, action);
    };
  }

  protected processReducerConfigArray(reducers: ReducerConfig[]): any {
    return reducers.reduce(function (reducers, currentReducerConfig) {
      return Object.assign(reducers, currentReducerConfig);
    }, {});
  }
}
